import { fetcher } from "@certn/api";
import { showToast } from "@certn/cascadia";
import { TFunction } from "i18next"; // Import from "i18next"
import { mutate as SWRMutate } from "swr";

export const toggleFavourite = async (
  id: string,
  isFavourite: boolean,
  t: TFunction,
  mutate: () => void
) => {
  try {
    await fetcher.submit(
      isFavourite
        ? `/api/internal/client-portal/customer-groups/${id}/favourite/delete/`
        : `/api/internal/client-portal/customer-groups/${id}/favourite/create/`,
      {}
    );

    // mutate groups list view
    await mutate();

    // mutate favourite groups list in AppNavigation (left bar)
    await SWRMutate(
      "/api/internal/client-portal/customer-groups/favourite-groups/"
    );

    showToast(
      isFavourite ? t("Removed favourite group") : t("Added favourite group"),
      { type: "success" }
    );
  } catch (e) {
    console.error(e);
    showToast(
      isFavourite ? t("Removed favourite group") : t("Added favourite group"),
      {
        type: "error",
      }
    );
  }
};
